var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M16.9561 15.7241L13.2402 12.0082L16.9507 8.29768C17.1439 8.10443 17.238 7.89418 17.233 7.66693C17.228 7.43969 17.1336 7.23413 16.9497 7.05027C16.7659 6.86641 16.5603 6.77198 16.3331 6.76698C16.1058 6.76198 15.8956 6.8561 15.7023 7.04936L11.9918 10.7599L8.2759 7.04392C8.09204 6.86006 7.8889 6.76804 7.6665 6.76788C7.44409 6.76772 7.24109 6.85943 7.0575 7.04303C6.86424 7.23628 6.7677 7.44411 6.76786 7.66652C6.76802 7.88893 6.86004 8.09206 7.0439 8.27592L10.7598 11.9919L7.04934 15.7024C6.86575 15.886 6.77403 16.0938 6.7742 16.3259C6.77437 16.5579 6.86639 16.7659 7.05025 16.9498C7.23411 17.1336 7.44208 17.2256 7.67416 17.2258C7.90624 17.226 8.11407 17.1343 8.29766 16.9507L12.0082 13.2402L15.7241 16.9561C15.908 17.14 16.1111 17.232 16.3335 17.2322C16.5559 17.2323 16.7637 17.1358 16.957 16.9425C17.1406 16.7589 17.2323 16.5559 17.2321 16.3335C17.232 16.1111 17.14 15.908 16.9561 15.7241Z",
    fill: "#9D9D9D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.f6686dc49fba1481c16e803bc1ba6e6c.svg";
export { ForwardRef as ReactComponent };